import CourseExamQuestionsSpec, {
  COURSE_EXAM_QUESTIONS_SPEC_TYPE,
  fromJS as courseExamQuestionsSpecFromJS
} from "./CourseExamQuestionsSpec";
import CourseSectionsSpec, {
  COURSE_SECTIONS_SPEC_TYPE,
  fromJS as courseSectionsSpecFromJS
} from "./CourseSectionsSpec";
import CourseUserSectionsSpec, {
  COURSE_USER_SECTIONS_SPEC_TYPE,
  fromJS as courseUserSectionsSpecFromJS
} from "./CourseUserSectionsSpec";
import QuizzesOnlySpec, {
  QUIZZES_ONLY_SPEC_TYPE,
  fromJS as quizzesOnlySpecFromJS
} from "./QuizzesOnlySpec";
import VocabularySpec, {
  VOCABULARY_SPEC_TYPE,
  fromJS as vocabularySpecFromJS
} from "./VocabularySpec";

export const specsMap = Object.freeze({
  [COURSE_SECTIONS_SPEC_TYPE]: {
    Record: CourseSectionsSpec,
    fromJS: courseSectionsSpecFromJS
  },
  [COURSE_EXAM_QUESTIONS_SPEC_TYPE]: {
    Record: CourseExamQuestionsSpec,
    fromJS: courseExamQuestionsSpecFromJS
  },
  [COURSE_USER_SECTIONS_SPEC_TYPE]: {
    Record: CourseUserSectionsSpec,
    fromJS: courseUserSectionsSpecFromJS
  },
  [QUIZZES_ONLY_SPEC_TYPE]: {
    Record: QuizzesOnlySpec,
    fromJS: quizzesOnlySpecFromJS
  },
  [VOCABULARY_SPEC_TYPE]: {
    Record: VocabularySpec,
    fromJS: vocabularySpecFromJS
  }
});

export const specTypes = Object.freeze({
  "course-sections": COURSE_SECTIONS_SPEC_TYPE,
  "course-exam-questions": COURSE_EXAM_QUESTIONS_SPEC_TYPE,
  "course-user-sections": COURSE_USER_SECTIONS_SPEC_TYPE,
  quizzes: QUIZZES_ONLY_SPEC_TYPE,
  vocabulary: VOCABULARY_SPEC_TYPE
});

export type SpecTypeType = (typeof specTypes)[keyof typeof specTypes];
